import { css } from "@emotion/core";
import { color, fonts, fontSizes, breakpoints } from "../../theme/Theme";

export const eligibilityTopStepsStyles = css({
  [`@media screen and (min-width: ${breakpoints.lg})`]: {
    paddingLeft: "15%",
    paddingRight: "15%"
  },
  ".ant-steps-item-container": {
    display: "flex",
    alignItems: "baseline"
  },
  ".active-step-title": {
    color: color.primary,
    fontFamily: fonts.bold,
    fontSize: fontSizes.placeholder
  },
  ".inactive-step-title": {
    color: color.placeholder,
    fontSize: fontSizes.placeholder
  }
});

export const commonFoldStyles = css({
  ".grid-container": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "1rem",
    columnGap: "5rem",
    [`@media screen and (max-width: ${breakpoints.sm})`]: {
      display: "flex",
      flexDirection: "column"
    }
  },
  ".full-width": {
    gridColumn: "span 2"
  }
});
